import Upsertable from '@/models/Upsertable'
import { useHarvestStore } from '@/stores/harvestStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Harvest extends Upsertable {
  static store() {
    return useHarvestStore()
  }

  store() {
    return Harvest.store()
  }

  static all() {
    return Harvest.store().getAll
  }

  static find(uuid) {
    const obj = Harvest.store().find(uuid)
    let harvest = new Harvest()
    return Object.assign(harvest, obj)
  }
}

useModelName(Harvest, "Harvest")
ModelRegistry.register(Harvest, "Harvest")